import Button from "./Button";
import "../css/custom.css";

const Address = ({ input, run }) => {
  return (
    <section className="pt-5">
      <div className="col-md-4 ms-5">
        <div
          className="form-outline mb-3"
          style={{ backgroundColor: "bs-dark" }}
        >
          <div className="input-group">
            <input
              className="input form-control active"
              onChange={input}
              id="address"
              placeholder="Enter Solana Stake Account..."
              type="text"
              autocomplete="off"
            ></input>
            <label className="form-label" htmlFor="address">
              Stake Address
            </label>
            <div className="form-notch">
              <div
                className="form-notch-leading"
                style={{ width: "9px" }}
              ></div>
              <div
                className="form-notch-middle"
                style={{ width: "88.8px" }}
              ></div>
              <div className="form-notch-trailing"></div>
            </div>
            <span className="input-group-btn">
              <Button
                cname="btn btn-light padding"
                text="Submit"
                onClick={run}
              />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Address;
